var addressautocomplete = new function () {
    this.addressautocomplete;
    this.addressList;
    this.isWorking = false;

    this.hideAddress = function (event, el) {
        var shipOrBill = $(el).data('ship-or-bill');
        $("#" + shipOrBill + "_woocommerce-addressautocomplete-address-selector").remove();
    }

    this.useSelectedAddress = function (event, el) {
        var shipOrBill = $(el).data('ship-or-bill');
        if ((el.selectedIndex) === 0) return false;
        let selectedAddress = addressautocomplete.addressList.address_list.addresses[el.selectedIndex - 1].address;

        $("#" + shipOrBill + "_address_1").val(selectedAddress.line_1);
        $("#" + shipOrBill + "_address_2").val(selectedAddress.line_2);
        $("#" + shipOrBill + "_city").val(selectedAddress.town_or_city);
        $("#" + shipOrBill + "_state").val(selectedAddress.county);

        $("#" + shipOrBill + "_postcode").val(addressautocomplete.addressList.postcode); //formats the user's postcode nicely
        $("#" + shipOrBill + "_woocommerce-addressautocomplete-address-selector").remove(); // removes dropdown after selecting
    }
    this.searchForAddress = function (event, el) {
        var shipOrBill = $(el).data('ship-or-bill');
        $(el).text('Searching...');
        $("#shipping_woocommerce-addressautocomplete-address-selector").remove();
        $("#billing_woocommerce-addressautocomplete-address-selector").remove();
        $("#billing_ajax-error-address").remove();
        $("#shipping_ajax-error-address").remove();
        if (shipOrBill === "shipping" || shipOrBill === "billing") {
            var postCode = $('#' + shipOrBill + '_postcode').val();
            if (typeof postCode === 'string') {
                jQuery.ajax({
                    type: 'POST',
                    url: address_autocomplete_settings.ajax_url,
                    cache: true,
                    data: {
                        action: 'addressautocomplete-search',
                        postCode: $('#' + shipOrBill + '_postcode').val(),
                        shipOrBill: shipOrBill,
                        _ajax_nonce: address_autocomplete_settings.nonce,
                    },
                    beforeSend: function (xhr) {
                        if (addressautocomplete.isWorking === false) {
                            addressautocomplete.isWorking = true
                        } else {
                            xhr.abort(); // stops visitors spamming the search button/calling several lookups before the 1st one is done
                        }
                    },
                    success: function (data, textStatus, XMLHttpRequest) {
                        if (addressautocomplete.isWorking === true) addressautocomplete.isWorking = false;
                        addressautocomplete.addressList = JSON.parse(data);
                        if (addressautocomplete.addressList.error_code) {
                            $(el).text('Find Address');
                            $("#" + shipOrBill + "_woocommerce-addressautocomplete-address-selector").remove();
                            var errorText = '<p class="form-row form-row-wide woocommerce-validated" id="' + shipOrBill + '_ajax-error-address">' +
                                '  <strong>Error!</strong> Your postcode appears to be invalid. Please try again or enter your address manually.\n' +
                                '</div></p>';
                            $(errorText).insertAfter("#" + shipOrBill + "_woocommerce_form_field_autoaddresscomplete_button_field");
                        } else {
                            $(addressautocomplete.addressList.fragment).insertAfter("#" + shipOrBill + "_woocommerce_form_field_autoaddresscomplete_button_field");
                            $(el).text('Find Address');
                        }

                    },
                    error: function (MLHttpRequest, textStatus, errorThrown) {
                        if (textStatus === 'error') {
                            $(el).text('Find Address');
                            $("#" + shipOrBill + "_woocommerce-addressautocomplete-address-selector").remove();
                            var errorText = '<p class="form-row form-row-wide woocommerce-validated" id="' + shipOrBill + '_ajax-error-address">' +
                                '  <strong>Error!</strong> We ran into a problem. Please enter your address manually.\n' +
                                '</div></p>';
                            $(errorText).insertAfter("#" + shipOrBill + "_woocommerce_form_field_autoaddresscomplete_button_field");
                        }

                    }

                });
            }
        }
    }
}